import { http, API_BASE_URL_TEST, API_BASE_URL_PROD, getError, catchError } from "services/http"
import i18next from "i18next"
import { getAccessToken } from "utils/user"
import { Entity, EntitySignin, ErrorFn, ErrorResponse, User } from "models"

const validateEmail = async (mail: string) => {
    const validateEmailErrors = (error: ErrorResponse) => {
        switch (error?.code) {
            case "MailNotAvailableException":
                return { code: error?.code, message: i18next.t("mail_error_MailNotAvailableException", { ns: "api" }) }
            case "TooManyRequestsException":
                return { code: error?.code, message: i18next.t("mail_error_TooManyRequestsException", { ns: "api" }) }
            default:
                return { code: error?.code, message: i18next.t("mail_error_default", { ns: "api" }) }
        }
    }
    // const res = await http.post(`authenticationapi/consumer/check_mail`, {mail}, {}).catch(e => http.catchError(e))
    const res = true
    return {
        res,
        getError: getError(res, validateEmailErrors)
    }
}

const resendMails = async (code: string, params: string): Promise<{ res: any } & ErrorFn> => {
    const resendMailsErrors = (error: ErrorResponse) => {
        switch (error?.code) {
            case "NotAuthorizedException":
                if (error?.message === "Operation is not allowed: role." || error?.message === "Operation is not allowed: operateur." || error?.message === "Operation is not allowed: status.") {
                    return { code: error?.code, message: i18next.t("edit_error_NotAuthorizedException", { ns: "api" }) }
                } else {
                    //logout() TODO
                    break
                }
            case "BikeNotFoundException":
                return { code: error?.code, message: i18next.t("search_error_BikeNotFoundException", { ns: "api" }) }
            case "InvalidArgument":
                return { code: error?.code, message: i18next.t("search_error_InvalidArgument", { ns: "api" }) }
            case "EntityStatusException":
                return { code: error?.code, message: i18next.t("edit_error_NotAuthorizedException", { ns: "api" }) }
            default:
                return { code: error?.code, message: i18next.t("sell_global_error", { ns: "api" }) }
        }
    }

    const res = await http
        .get(`obikeapi/auth_store/bike/resendmails?bike_id=${code}${params}`, {})
		.then((res) => res.data)
        .catch(e => catchError(e))
    return {
        res,
        getError: getError(res as unknown as ErrorResponse, resendMailsErrors)
    }
}

const signIn = async (mail: string, password: string): Promise<{ res: EntitySignin } & ErrorFn> => {
    const signinErrors = (error: ErrorResponse) => {
        switch (error?.code) {
            case "NotAuthorizedException":
                switch (error?.message) {
                    case "OneMatch":
                        return { code: error?.code, message: i18next.t("signin_global_error_OneMatch", { ns: "api" }) }
                    default:
                        return { code: error?.code, message: i18next.t("signin_error_NotAuthorizedException", { ns: "api" }) }
                }
            case "TooManyRequestsException":
                return { code: error?.code, message: i18next.t("signin_error_TooManyRequestsException", { ns: "api" }) }
            default:
                return { code: error?.code, message: i18next.t("signin_error_default", { ns: "api" }) }
        }
    }
    const res = await http
        .post<EntitySignin>("obikeapi/entity/signin", { mail, password }, {})
		.then((res) => res.data)
        .catch(e => catchError(e))
    return {
        res: res as EntitySignin,
        getError: getError(res, signinErrors)
    }
}

const signInAsSupport = async (entity_id: string): Promise<{ res: any } & ErrorFn> => {
    const signinAsSupportErrors = (error: ErrorResponse) => {
        switch (error?.code) {
            case "NotAuthorizedException":
                return { code: error?.code, message: i18next.t("signin_backend_error_NotAuthorizedException", { ns: "api" }) }
            case "EntityNotFoundException":
                return { code: error?.code, message: i18next.t("signin_backend_error_EntityNotFoundException", { ns: "api" }) }
            default:
                return { code: error?.code, message: i18next.t("signin_backend_error_default", { ns: "api" }) }
        }
    }
    const baseURL = process.env.REACT_APP_MODE === "production" ? API_BASE_URL_PROD : API_BASE_URL_TEST
    // Get support token (token to access platform as support)
    // (token should not be automatically stored by Axios so we use Fetch here)
    const res = await fetch(`${baseURL}obikeapi/backend/signin`, {
        method: "POST",
        body: JSON.stringify({
            entity_id
        }),
        headers: new Headers({
            "Content-Type": "application/json",
            "Accept": "application/json",
            "Accept-Version": "1.0.0",
            "Authorization": `Bearer ${getAccessToken()}`
        }),
    })
        .then(response => response.json())
        .then(data => data)
        .catch(error => catchError(error))


    return {
        res,
        getError: getError(res, signinAsSupportErrors)
    }
}

const activateAccount = async (token: string, password: string): Promise<{ res: any } & ErrorFn> => {
    const activateAccountErrors = (error: ErrorResponse) => {
        switch (error?.code) {
            case "NotAuthorizedException":
                return { code: error?.code, message: i18next.t("activate_account_error_NotAuthorizedException", { ns: "api" }) }
            case "TooManyRequestsException":
                return { code: error?.code, message: i18next.t("activate_account_error_TooManyRequestsException", { ns: "api" }) }
            default:
                return { code: error?.code, message: i18next.t("activate_account_error_default", { ns: "api" }) }
        }
    }

    const res = await http
        .put("obikeapi/entity/activate_account", password, {
			headers: { Authorization: `Bearer ${token}` },
		})
		.then((res) => res.data)
        .catch(e => catchError(e))

    return {
        res,
        getError: getError(res, activateAccountErrors)
    }
}

const getEntity = async (entity_id: string): Promise<{ res: Entity } & ErrorFn> => {
    const getEntityErrors = (error: ErrorResponse) => {
        switch (error?.code) {
            default:
                return { code: error?.code, message: i18next.t("add_global_error", { ns: "api" }) }
        }
    }

    const res = await http
        .get<Entity>(`obikeapi/entity?entity_id=${entity_id}`, {})
		.then((res) => res.data)
        .catch(e => catchError(e))

	return {
		res: res as Entity,
        getError: getError(res, getEntityErrors)
	}
}

const getEntityByOldStoreId = async (old_store_id: string): Promise<{ res: Entity }> => {
    const res = await http
        .get<Entity>(`obikeapi/entity?old_store_id=${old_store_id}`, {})
		.then((res) => res.data)
        .catch(e => catchError(e))
    // console.log("getEntity res: ", res)
	return {
		res: res as Entity
	}
}

const getUser = async (user_id: string): Promise<{ res: User } & ErrorFn> => {
    const getUserErrors = (error: ErrorResponse) => {
        // TODO: return real error object
        switch (error?.code) {
            case "NotAuthorizedException":
                switch (error?.message) {
                    case "Access token is required.":
                        return { code: error?.code, message: i18next.t("sell_error_AccessTokenRequired", { ns: "api" }) }
                    case "Operation is not allowed: role.":
                    case "Operation is not allowed: operateur.":
                        return { code: error?.code, message: i18next.t("edit_error_NotAuthorizedException", { ns: "api" }) }
                    default:
                        return { code: error?.code, message: i18next.t("add_global_error", { ns: "api" }) }
                }
            case "EntityNotFoundException":
            case "UserNotFoundException":
                return { code: error?.code, message: i18next.t("edit_errorUserNotFoundException", { ns: "api" }) }
            default:
                return { code: error?.code, message: i18next.t("add_global_error", { ns: "api" }) }
        }
    }
    const res = await http
        .get<User>(`obikeapi/entity/user?user_id=${user_id}`, {})
		.then((res) => res.data)
        .catch(e => catchError(e))
    // console.log("getUser res: ", res)
    return {
        res: res as User,
        getError: getError(res, getUserErrors)
    }
}

const initPassword = async (email: string, template: string): Promise<{ res: any } & ErrorFn> => {
    const initPasswordErrors = (error: ErrorResponse) => {
        switch (error?.code) {
            case "NotAuthorizedException":
                switch (error?.message) {
                    case "OneMatch":
                        return { code: error?.code, message: i18next.t("mail_update_error_OneMatch", { ns: "api" }) }
                    default:
                        return { code: error?.code, message: i18next.t("mail_update_error_default", { ns: "api" }) }
                }
            case "EmailUnknownException":
                return { code: error?.code, message: i18next.t("mail_update_error_EmailUnknownException", { ns: "api" }) }
            default:
                return { code: error?.code, message: i18next.t("mail_update_error_default", { ns: "api" }) }
        }
    }
    const res = await http
        .get(`obikeapi/entity/user/initpassword?mail=${email}&registermailtemplate=${template}`, {})
		.then((res) => res.data)
        .catch(e => catchError(e))

    return {
        res,
        getError: getError(res, initPasswordErrors)
    }
}

const updatePassword = async (code: string, newpassword: string, mail: string): Promise<{ res: any } & ErrorFn> => {
    const updatePasswordErrors = (error: ErrorResponse) => {
        switch (error?.code) {
            case "NotAuthorizedException":
                return { code: error?.code, message: i18next.t("updatePassword_error_NotAuthorizedException", { ns: "api" }) }
            default:
                return { code: error?.code, message: i18next.t("updatePassword_error_default", { ns: "api" }) }
        }
    }
    const apiObj = {
        mail: mail,
        newpassword: newpassword,
        recovery_password: code
    }

    const res = await http
        .post("obikeapi/entity/user/setpassword", apiObj, {})
		.then((res) => res.data)
        .catch(e => catchError(e))
    return {
        res,
        getError: getError(res, updatePasswordErrors)
    }
}

const sendMailToManager = async (manager: string): Promise<{ res: any } & ErrorFn> => {
    const sendMailToManagerErrors = (error: ErrorResponse) => {
        switch (error?.code) {
            case "NotAuthorizedException":
                switch (error?.message) {
                    case "Access token is required.":
                        return { code: error?.code, message: i18next.t("add_global_error", { ns: "api" }) }
                    default:
                        return { code: error?.code, message: i18next.t("edit_error_NotAuthorizedException", { ns: "api" }) }
                }
            case "EntityNotFoundException":
                return { code: error?.code, message: i18next.t("edit_errorEntityNotFoundException", { ns: "api" }) }
            case "UserNotFoundException":
                return { code: error?.code, message: i18next.t("edit_errorUserNotFoundException", { ns: "api" }) }
            case "MailNotAvailableException":
                return { code: error?.code, message: i18next.t("edit_MailNotAvailableException", { ns: "api" }) }
            case "TooManyRequestsException":
            case "UserVersionMismatchException":
                return { code: error?.code, message: i18next.t("edit_error_TooManyRequestsException", { ns: "api" }) }
            default:
                return { code: error?.code, message: i18next.t("add_global_error", { ns: "api" }) }
        }
    }
    //const res = true
    const res = await http
        .put("obikeapi/entity/user", manager, {})
		.then((res) => res.data)
        .catch(e => catchError(e))
    return {
        res,
        getError: getError(res as unknown as ErrorResponse, sendMailToManagerErrors)
    }
}

const getActivationLink = async (mail: string, template: string): Promise<{ res: any } & ErrorFn> => {
    const getActivationLinkErrors = (error: ErrorResponse) => {
        switch (error?.code) {
            case "NotAuthorizedException":
                if (error?.message === "NoneOrMany") {
                    return { code: error?.code, message: i18next.t("account_error_NotAuthorizedExceptionNoneOrMany", { ns: "api" }) }
                } else if (error?.message === "StatusNotZero") {
                    return { code: error?.code, message: i18next.t("account_error_NotAuthorizedExceptionStatusNotZero", { ns: "api" }) }
                }
                break
            default:
                return { code: error?.code, message: i18next.t("account_global_error", { ns: "api" }) }
        }
    }

    const res = await http
        .get(`obikeapi/entity/user/getactivationlink?mail=${mail}&registermailtemplate=${template}`, {})
		.then((res) => res.data)
        .catch(e => catchError(e))
    // console.log("getActivationLink res: ", res)
    return {
        res,
        getError: getError(res as unknown as ErrorResponse, getActivationLinkErrors)
    }
}

const getUserByMail = async (mail) => {
    const getUserByMailErrors = (error: ErrorResponse) => {
        switch (error?.code) {
            case "NotAuthorizedException":
                switch (error?.message) {
                    case "Access token is required.":
                        break
                    case "Operation is not allowed: role.":
                    case "Operation is not allowed: operateur.":
                        return { code: error?.code, message: i18next.t("edit_error_NotAuthorizedException", { ns: "api" }) }
                    default:
                        break
                }
                break
            case "EntityNotFoundException":
                return { code: error?.code, message: i18next.t("edit_errorEntityNotFoundException", { ns: "api" }) }
            case "UserNotFoundException":
                return { code: error?.code, message: i18next.t("edit_errorUserNotFoundException", { ns: "api" }) }
            default:
                return { code: error?.code, message: i18next.t("get_infos_error", { ns: "api" }) }
        }
    }
    const res = await http
        .get(`obikeapi/entity/user?mail=${mail}`, {})
		.then((res) => res.data)
        .catch(e => catchError(e))
    // console.log("getUserByMail res: ", res)
    return {
        res,
        getError: getError(res, getUserByMailErrors)
    }
}


export {
    validateEmail,
    resendMails,
    signIn,
    signInAsSupport,
    activateAccount,
    getEntity,
    getUser,
    updatePassword,
    initPassword,
    sendMailToManager,
    getEntityByOldStoreId,
    getActivationLink,
    getUserByMail
}
